import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "onboarding-signup__dots" }
const _hoisted_2 = ["onClick"]

import { signupBannerPages } from '@/models/onboarding.pages'

import SignupBannerItem from './SliderItem.vue'

import { ref, onMounted, onUnmounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Slider',
  setup(__props) {

const currentPosition = ref(0)
const container = ref<HTMLElement | null>(null)

const changeSlide = (newPosition: number): void => {
  if (!container.value) {
    return
  }

  container.value.scrollTo({
    left: newPosition * ((container.value.scrollWidth - 20) / 3),
    behavior: 'smooth',
  })

  currentPosition.value = newPosition
}

const handleScroll = (): void => {
  if (!container.value) {
    return
  }

  const scrollPosition = container.value.scrollLeft
  const slideWidth = (container.value.scrollWidth - 20) / 3
  const newPosition = Math.round(scrollPosition / slideWidth)

  currentPosition.value = newPosition
}

onMounted(() => {
  container.value?.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  container.value?.removeEventListener('scroll', handleScroll)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref_key: "container",
      ref: container,
      class: "onboarding-signup__slider"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(signupBannerPages), (page) => {
        return (_openBlock(), _createBlock(SignupBannerItem, {
          key: page.title,
          page: page
        }, null, 8, ["page"]))
      }), 128))
    ], 512),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(signupBannerPages), (page, index) => {
        return (_openBlock(), _createElementBlock("button", {
          key: index,
          class: _normalizeClass(["onboarding-signup__dot", {
        'onboarding-signup__dot--active': currentPosition.value === index,
      }]),
          onClick: ($event: any) => (changeSlide(index))
        }, null, 10, _hoisted_2))
      }), 128))
    ])
  ], 64))
}
}

})